module.exports = __webpack_public_path__ + "static/media/CEPsinistro.ab09e7ba.svg";